import { h, render } from 'preact';

import InactivePage from '@/base/page/InactivePage';
import { Utils, riperStorage, RiperHooks, i18n } from '@/base/helpers';
import { renderPreviewModeNotice, renderStagingEnvBadge } from '@/base/badge';
import Liana from './liana/app';
import Bamboo from './bamboo/app';
import Snow from './snow/app';
import Beans3 from './beans';

const Riper = {
  getRiperDisplay: () =>
    new Promise(function (resolve) {
      Beans3.get({ path: `${Beans3._trellis}/display/current/`, namespace: 'trellis' })
        .then(resolve)
        .catch(() => resolve(null));
    }),
  navigateToSection() {
    const rulesUids = Object.keys(riperStorage.templets);
    const currentURL = new URL(window.location);
    const hash = currentURL.hash.substring(1);

    if (!rulesUids.includes(hash)) return null;

    if (hash === 'rule:liana:display') return riperStorage.onAbout();
    if (hash === 'rule:liana:display_cart') return riperStorage.onViewCart();
    if (hash === 'rule:bamboo:display') return riperStorage.onAboutBamboo();

    return Bamboo.Popup.render(hash, { coupon_value: riperStorage.riperDisplay.popup.coupon_value });
  },
  init(args) {
    const currentScriptArgs = Beans3._utils.getCurrentScriptArgs();

    if (window.RiperArgs) {
      args = { ...args, ...window.RiperArgs };
    }

    RiperHooks.init();

    // RiperHooks.onPreInit({ args });

    riperStorage.args = { ...args, ...currentScriptArgs };
    riperStorage.onLogin = args.onLogin || args.onRegister;
    riperStorage.onRegister = args.onRegister || args.onLogin;
    riperStorage.onAbout = args.onAbout;
    riperStorage.onViewCart = args.onViewCart;
    riperStorage.onAboutBamboo = args.onAboutBamboo;
    riperStorage.currentPage = args.currentPage;

    if (args.Redemption) Liana.Redemption = args.Redemption;

    window.Beans3.riperStorage = riperStorage;
    window.Beans3.Liana = Liana;
    window.Beans3.Bamboo = Bamboo;
    window.Beans3.Snow = Snow;

    const getPagePlaceholder = () =>
      document.getElementById('liana-rewards-page') || document.getElementById('bamboo-referral-page');

    const renderErrorToPlaceholder = (error) => {
      return new Promise((resolve) => {
        const attemptRender = (iteration) => {
          const pagePlaceholder = getPagePlaceholder();

          if (pagePlaceholder) {
            pagePlaceholder.innerHTML = '';
            render(<InactivePage message={Utils.getErrors(error)} />, pagePlaceholder);
            resolve();
          } else if (iteration < 3) {
            setTimeout(() => attemptRender(iteration + 1), 1000);
          } else {
            resolve();
          }
        };

        if (/complete|interactive|loaded/.test(document.readyState)) {
          attemptRender(0);
        } else {
          document.addEventListener('DOMContentLoaded', () => attemptRender(0));
        }
      });
    };

    /**
     * initPromise makes it possible to return a promise response
     * that allows other actions to run after initialization.
     */
    let initPromiseResolve;
    let initPromiseReject;

    const initPromise = new Promise(function (resolve, reject) {
      initPromiseResolve = function (responses) {
        if (window.location.hash) {
          Riper.navigateToSection();
        }

        Utils.createDOMPromise(() =>
          RiperHooks.onPostInit({ display: riperStorage.riperDisplay, account: riperStorage.account })
        );

        resolve(responses);
      };
      initPromiseReject = function (error) {
        // if (typeof error.error === 'object') error = error.error;

        renderErrorToPlaceholder(error).then(() => reject(error));
      };
    });

    Promise.all([this.getRiperDisplay(), args.Auth.authenticate()])
      .then(function ([riperDisplay, account]) {
        /**
         * This is used as auth token for trellis @deprecated
         * Can only be removed after all shops has migrated to Trellis / V4
         */
        Beans3.cardId = riperDisplay.card;

        riperStorage.riperDisplay = riperDisplay;
        riperStorage.account = account;

        riperStorage.templets['rule:liana:display'] = riperDisplay.templet_loyalty_page;
        riperStorage.templets['rule:liana:display_cart'] = riperDisplay.templet_loyalty_redemption;
        riperStorage.templets['rule:bamboo:display'] = riperDisplay.templet_referral_page;
        riperStorage.templets['rule:bamboo:display_popup_reward'] = riperDisplay.templet_referral_reward;
        riperStorage.templets['rule:bamboo:display_popup_invite'] = riperDisplay.templet_referral_invite;

        if (account && account.id && !account.is_active) {
          throw new Error(`Your rewards program account ${account.email} has been deactivated.`);
        }

        i18n
          .init(riperDisplay.language)
          .then(() => {
            Liana.init({ args, riperDisplay, account });
            Bamboo.init({ args, riperDisplay, account });
            Snow.init({ args, riperDisplay, account });

            initPromiseResolve([]);
          })
          .catch(initPromiseReject);

        if (!Beans3.isEnvProd()) {
          renderStagingEnvBadge(Beans3._utils.getOrCreateContainer(document.body, 'beans-staging-badge'), render);
        }

        if (Beans3.previewSession.isActive()) {
          renderPreviewModeNotice(Beans3._utils.getOrCreateContainer(document.body, 'beans-preview-mode'), render);
        }
      })
      .catch(initPromiseReject);

    return initPromise;
  },
};

export default Riper;
